export const services = [
  {
    id: 'photography-studio',
    title: 'Photography Studio Rentals',
    slug: '/services',
    description: 'Fully-equipped studios with professional lighting, seamless backdrops, and open space layouts built for any shoot.',
    image: 'https://public.readdy.ai/ai/img_res/133f32bf35072bcddb7e8357c7307c60.jpg',
    icon: 'ri-camera-lens-line',
    features: ['Studio Lighting', 'Multiple Backdrops', 'Props & Stands', 'Dressing Room'],
  },
  {
    id: 'video-production',
    title: 'Video Production Studios',
    slug: '/services',
    description: 'Cinema-grade production rooms with acoustic treatment, teleprompters, green screens, and broadcast-ready setups.',
    image: 'https://readdy.ai/api/search-image?query=Professional%20video%20production%20studio%20with%20cinema%20camera%20on%20dolly%20rig%2C%20LED%20panel%20lighting%20array%2C%20dark%20acoustic%20foam%20wall%20panels%2C%20warm%20cinematic%20amber%20teal%20lighting%2C%20film%20production%20broadcast%20environment%2C%20professional%20grade%20equipment%2C%20modern%20industrial%20studio%20space%2C%20moody%20dramatic%20atmosphere&width=600&height=400&seq=vid001&orientation=landscape',
    icon: 'ri-film-line',
    features: ['4K Camera Ready', 'Teleprompter', 'Acoustic Treatment', 'Green Screen'],
  },
  {
    id: 'podcast-studio',
    title: 'Podcast Recording Studios',
    slug: '/services',
    description: 'Soundproofed recording booths with professional broadcast microphones, mixing consoles, and comfortable setups.',
    image: 'https://readdy.ai/api/search-image?query=Intimate%20podcast%20recording%20studio%20with%20professional%20condenser%20broadcast%20microphones%20on%20articulating%20arms%2C%20acoustic%20foam%20wall%20panels%2C%20warm%20LED%20strip%20lighting%2C%20professional%20mixing%20console%2C%20comfortable%20leather%20seating%2C%20dark%20cozy%20broadcast%20atmosphere%2C%20modern%20radio%20studio%20aesthetic&width=600&height=400&seq=pod001&orientation=landscape',
    icon: 'ri-mic-line',
    features: ['Soundproof Booth', 'Broadcast Mics', 'Mixing Console', 'Live Streaming Ready'],
  },
  {
    id: 'content-creation',
    title: 'Content Creation Spaces',
    slug: '/services',
    description: 'Versatile spaces designed for influencers, brands, and digital creators with fully flexible setups and streaming gear.',
    image: 'https://readdy.ai/api/search-image?query=Modern%20content%20creation%20studio%20space%20with%20professional%20ring%20lights%20on%20stands%2C%20colorful%20interchangeable%20backdrop%20wall%20panels%2C%20streaming%20camera%20setup%20on%20tripod%2C%20clean%20white%20walls%2C%20ergonomic%20furniture%2C%20bright%20clean%20studio%20lighting%2C%20influencer%20creator%20minimal%20aesthetic%2C%20modern%20studio%20interior&width=600&height=400&seq=cnt001&orientation=landscape',
    icon: 'ri-smartphone-line',
    features: ['Ring Lights', 'Multiple Backdrops', 'Streaming Setup', 'High-Speed WiFi'],
  },
  {
    id: 'event-space',
    title: 'Event & Creative Space Rentals',
    slug: '/services',
    description: 'Flexible open-plan creative spaces ideal for workshops, brand activations, pop-ups, and large productions.',
    image: 'https://readdy.ai/api/search-image?query=Creative%20event%20workshop%20loft%20space%20with%20exposed%20brick%20walls%2C%20Edison%20bulb%20string%20lights%20hanging%20overhead%2C%20flexible%20modern%20seating%20arrangements%2C%20large%20industrial%20windows%20with%20natural%20light%2C%20polished%20concrete%20floor%2C%20warm%20amber%20ambient%20lighting%2C%20open%20creative%20venue%20space%2C%20urban%20loft%20aesthetic&width=600&height=400&seq=evt001&orientation=landscape',
    icon: 'ri-calendar-event-line',
    features: ['Open Floor Plan', 'AV Equipment', 'Catering Area', 'Flexible Layout'],
  },
];

export const locations = [
  { city: 'New York City', state: 'NY', studios: 12, slug: '/locations', description: 'SoHo, Midtown & Brooklyn studios' },
  { city: 'Los Angeles', state: 'CA', studios: 9, slug: '/locations', description: 'Hollywood, DTLA & Silver Lake' },
  { city: 'Chicago', state: 'IL', studios: 6, slug: '/locations', description: 'West Loop & River North studios' },
  { city: 'Miami', state: 'FL', studios: 5, slug: '/locations', description: 'Wynwood & Brickell studios' },
  { city: 'Austin', state: 'TX', studios: 4, slug: '/locations', description: 'East Austin & South Congress' },
  { city: 'Atlanta', state: 'GA', studios: 5, slug: '/locations', description: 'Midtown & Old Fourth Ward' },
];

export const pricingTiers = [
  { label: 'Hourly', from: 45, unit: '/hr', description: 'Perfect for quick shoots' },
  { label: 'Half-Day', from: 165, unit: '/4hrs', description: 'Most popular choice' },
  { label: 'Full-Day', from: 299, unit: '/day', description: 'Best value for productions' },
];
